import lfRequest from '@/service/index'

enum Common {
  getKey = '/admin/getKey',
  getPolicy = '/oss/policy'
}

export function getKeyRequest() {
  return lfRequest.post<string>({
    url: Common.getKey
  })
}

export function getPolicy() {
  return lfRequest.get<any>({
    url: Common.getPolicy
  })
}

export function dayTop(url: string, type: number) {
  return lfRequest.get<any>({
    url: url,
    params: { type }
  })
}
